import { createAuthClient } from "better-auth/react";

// Client Better Auth (composants React). baseURL par défaut = même origine que le site.
export const authClient = createAuthClient();

export const { signIn, signUp, signOut, useSession, requestPasswordReset, resetPassword } = authClient;
